import Vue from 'vue'
import App from './App.vue'
// 路由
import router from './router'
// vuex
import store from './store'
// 权限
import './permission'
// 样式
import './style/index.scss'
// ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// ElementUI主题
import './style/style/theme/index.scss'
// 插件
import vuePlugin from './vuePlugin'
// 动画
import 'animate.css'
// ECharts
import ECharts from 'vue-echarts'
import 'echarts'

Vue.component('v-chart', ECharts)

Vue.use(vuePlugin)
Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.prototype.$beard = []
Vue.prototype.$selectBeard = ['/index/index/info']
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
